import React, {useState} from 'react'

export const Caesar = ({alphabetKey, alphabet}) => {
    const [decipheredCode, setDecipheredCode] = useState('');

    let cipherDecoder = (shiftKey) => {
        let cipherObject = {}

        const alphabetLength = alphabet.length

        for(let i = 0; i < alphabetLength; i++) {
            let position = +i + +shiftKey;

            if (position < 0) {
                position = alphabetLength - Math.abs(position)
            } else if (position > alphabetLength - 1) {
                position = Math.abs(alphabetLength - position)
            }

            cipherObject[i] = alphabet[position]
        }

        return cipherObject
    }

    const handleCaesarDecipher = (e) => {
        e.preventDefault()
console.log('fired')


        const code = e.target.caesar_code.value.toLowerCase().toString()
        const shift = e.target.shift.value || 0

        let decodedCipher = cipherDecoder(shift)

        let decipheredCode  = ''

        for (let i in code) {
            const letter = code[i]

            if (/^[a-z]+$/.test(letter) === true) {
                let cipheredLetter = decodedCipher[alphabetKey[letter]]

                decipheredCode += cipheredLetter
            } else {
                decipheredCode += letter
            }
        }

        setDecipheredCode(decipheredCode)
    }

    return (
        <div>
            <h2>Caesar Cypher</h2>
            <p>The Caesar cipher is used to decode words by using the alphabet and a key that shifts the letters. This key could be a single value,
                which is then used to shift the letters by the key's specified value. Or, it could be more complex, like a year that is used to shift the message repeatedly.</p>

            <p>Insert your coded message and keys in the box, and the decoded message will be shown beneath it.</p>

            <form action="#" onSubmit={(e)=>handleCaesarDecipher(e)}>
                <label htmlFor="shift" type="number">Shift Key</label>
                <br />
                <input name="shift" type="text" />
                <br />
                <label htmlFor="caesar_code">Encoded Message</label>
                <br />
                <input name="caesar_code" type="text" />
                <button>Decode</button>
            </form>

            {decipheredCode !== '' && <p className="results">Result: {decipheredCode}</p>}
        </div>
    )
}
